import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

export type StatusTone = "ok" | "warning" | "danger" | "info" | "neutral";

/**
 * Color + palabra. Nunca sólo color.
 *
 * En un mostrador hay reflejos, pantallas mal calibradas y personas con
 * daltonismo. "PAGADO" tiene que leerse aunque el verde no se distinga.
 */
const TONE_CLASSES: Record<StatusTone, string> = {
  ok: "bg-success-soft text-success border-success/30",
  warning: "bg-warning-soft text-warning border-warning/30",
  danger: "bg-danger-soft text-danger border-danger/30",
  info: "bg-electric/10 text-electric-text border-electric/30",
  neutral: "bg-surface text-muted border-line",
};

export interface StatusPillProps {
  tone?: StatusTone;
  children: ReactNode;
  className?: string;
}

export function StatusPill({ tone = "neutral", children, className }: StatusPillProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap",
        TONE_CLASSES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
